import React from "react";
import { tickerItems } from "../data/siteContent";

const MarqueeRow = () => (
  <span className="flex items-center">
    {tickerItems.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display italic text-2xl sm:text-3xl text-cream/25 px-8 whitespace-nowrap">
          {item}
        </span>
        <span className="text-gold text-lg" aria-hidden="true">
          &#10022;
        </span>
      </span>
    ))}
  </span>
);

const Marquee = () => {
  return (
    <div
      className="border-y border-gold/15 bg-inkdeep py-6 sm:py-8 overflow-hidden"
      data-testid="editorial-marquee"
    >
      <div className="marquee-track">
        <MarqueeRow />
        <MarqueeRow />
      </div>
    </div>
  );
};

export default Marquee;
